
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5s27v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


const $16e27872478384c0$export$7f1bcb54a9a4d80e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kWSCB",
    name: "ShortcutsSection",
    loader: async ()=>(await (parcelRequire("8NpIa"))).ShortcutsSection
});


/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");





var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $j1Ss3 = parcelRequire("j1Ss3");


var $9hlns = parcelRequire("9hlns");


var $bTdbD = parcelRequire("bTdbD");


var $4NZXC = parcelRequire("4NZXC");


var $5izcQ = parcelRequire("5izcQ");


var $c1ydB = parcelRequire("c1ydB");

var $dXXAF = parcelRequire("dXXAF");

var $cNRxA = parcelRequire("cNRxA");


var $3qtLb = parcelRequire("3qtLb");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");





var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $9eE57 = parcelRequire("9eE57");

/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 



var $xQxzY = parcelRequire("xQxzY");




/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $f8a43fdc91a5738e$export$8d4d3d8b2da7ecab = /*#__PURE__*/ function(PageCardInPageTreeHoverPreference) {
    PageCardInPageTreeHoverPreference["NO_OPTION_SELECTED"] = "NO_OPTION_SELECTED";
    PageCardInPageTreeHoverPreference["NO_SHOW_PAGECARD"] = "NO_SHOW_PAGECARD";
    PageCardInPageTreeHoverPreference["SHOW_PAGECARD"] = "SHOW_PAGECARD";
    return PageCardInPageTreeHoverPreference;
}({});


const $2d41bbac85093ab1$var$useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery = (0, $eSUdr.default)`query useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery{userPreferences{shouldShowCardOnPageTreeHover}}`;
const $2d41bbac85093ab1$export$f824d805fc04fcb2 = ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: data } = (0, $xQxzY.useQuery)($2d41bbac85093ab1$var$useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery, {
        skip: !isLicensed
    });
    // don't render popups for anon users.
    // This is after the useQuery because conditionally running hooks isn't allowed.
    if (!isLicensed) return {
        isHoverPageCardOptedIn: false
    };
    const userPreference = data?.userPreferences?.shouldShowCardOnPageTreeHover;
    return {
        isHoverPageCardOptedIn: userPreference !== (0, $f8a43fdc91a5738e$export$8d4d3d8b2da7ecab).NO_SHOW_PAGECARD
    };
};


const $f35e894e447c6262$export$2de55e286c149cfa = 300;
const $f35e894e447c6262$export$1bbe776c3ae63e35 = 400;
const $f35e894e447c6262$export$3bba19b3f6dc31cd = (source)=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isHoverPageCardOptedIn: isHoverPageCardOptedIn } = (0, $2d41bbac85093ab1$export$f824d805fc04fcb2)();
    // the tree item id and the trigger should be grouped into one state as the trigger always corresponds with the itemID
    // this prevents unnecessary rerenders of the hover page card
    const [showHoverPageCardForItem, setShowHoverPageCardForItem] = (0, $42omo.useState)({
        itemID: null,
        trigger: null
    });
    const openSidebarPopupTimerRef = (0, $42omo.useRef)(null);
    const closeSidebarPopupTimerRef = (0, $42omo.useRef)(null);
    /**
   * Cancel the open sidebar popup cards timer
   */ const clearOpenSidebarPopupTimer = (0, $42omo.useCallback)(()=>{
        if (openSidebarPopupTimerRef?.current) {
            clearTimeout(openSidebarPopupTimerRef.current);
            openSidebarPopupTimerRef.current = null;
        }
    }, [
        openSidebarPopupTimerRef
    ]);
    /**
   * Cancel the close sidebar popup cards timer
   */ const clearCloseSidebarPopupTimer = (0, $42omo.useCallback)(()=>{
        if (closeSidebarPopupTimerRef.current) {
            clearTimeout(closeSidebarPopupTimerRef?.current);
            closeSidebarPopupTimerRef.current = null;
        }
    }, [
        closeSidebarPopupTimerRef
    ]);
    /**
   * On mouse enter/focus of the hover target, create a hover card for that itemId
   * Start the timer which will open the popup if the user hovers on the tree item for HOVER_DELAY_TIME.
   * Clears any closePageCard timers since we don't need to close the popup, we can just replace the showHoverPageCardForItem.
   * This is called onMouseOver of page tree items.
   */ const onEnterHoverTarget = (0, $42omo.useCallback)(({ itemID: itemID, isQuickActionsFocused: isQuickActionsFocused, hoverPageCardTriggerRef: hoverPageCardTriggerRef, isContextualCreateFocused: isContextualCreateFocused })=>{
        clearCloseSidebarPopupTimer();
        // only show a hover card if it matches to conditions to show it and it isn't already showing a card for the same itemID
        if (isHoverPageCardOptedIn && !isQuickActionsFocused && !isContextualCreateFocused && showHoverPageCardForItem.itemID !== itemID) {
            if (openSidebarPopupTimerRef.current === null) openSidebarPopupTimerRef.current = setTimeout(()=>{
                // this setstate is the one and only line that causes SpaceHoverPageCard to rerender
                setShowHoverPageCardForItem({
                    itemID: itemID,
                    trigger: hoverPageCardTriggerRef
                });
                experienceTracker.start({
                    name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).SPACE_VIEWS,
                    attributes: {
                        source: source
                    }
                });
                (0, $9eE57.perfMarkStart)({
                    subject: 'HoverPageCard',
                    subjectId: 'rendered'
                });
                openSidebarPopupTimerRef.current = null;
            }, $f35e894e447c6262$export$2de55e286c149cfa);
        }
    }, // adding showHoverPageCardForItem into the dependency array causes the entire page tree to rerender on any item hover.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        clearCloseSidebarPopupTimer,
        experienceTracker,
        isHoverPageCardOptedIn,
        source
    ]);
    /**
   * Closes all popups after CLOSE_DELAY_TIME if the closeSidebarPopupTimerRef timer has not been cleared before then
   * Called on mouse leave of a page tree item
   */ const startCloseHoverPageCardTimer = (0, $42omo.useCallback)(()=>{
        experienceTracker.abort({
            name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
            reason: 'Popup closed'
        });
        clearOpenSidebarPopupTimer();
        if (closeSidebarPopupTimerRef.current === null) closeSidebarPopupTimerRef.current = setTimeout(()=>{
            setShowHoverPageCardForItem({
                itemID: null,
                trigger: null
            });
            closeSidebarPopupTimerRef.current = null;
        }, $f35e894e447c6262$export$1bbe776c3ae63e35);
    }, [
        experienceTracker,
        clearOpenSidebarPopupTimer
    ]);
    /**
   * Clear all the timers, called when the mouse reenters
   */ const clearHoverPageCardTimers = (0, $42omo.useCallback)(()=>{
        clearOpenSidebarPopupTimer();
        clearCloseSidebarPopupTimer();
    }, [
        clearOpenSidebarPopupTimer,
        clearCloseSidebarPopupTimer
    ]);
    /**
   * Immediately force close all popups when this is called.
   * Called when the popup is clicked on or when the page is redirected
   */ const closeAllHoverPageCards = (0, $42omo.useCallback)(()=>{
        clearHoverPageCardTimers();
        setShowHoverPageCardForItem({
            itemID: null,
            trigger: null
        });
        experienceTracker.abort({
            name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
            reason: 'Popup closed'
        });
    }, [
        experienceTracker,
        clearHoverPageCardTimers
    ]);
    /**
   * On mouseleave of the hover target, start close timer for that item's hover card
   */ const onLeaveHoverTarget = (0, $42omo.useCallback)(()=>{
        startCloseHoverPageCardTimer();
    }, [
        startCloseHoverPageCardTimer
    ]);
    /**
   * On blur of the hover target, start close timer for that item's hover card
   */ const onBlurHoverTarget = (0, $42omo.useCallback)((e)=>{
        if (!e.currentTarget.contains(e.relatedTarget)) startCloseHoverPageCardTimer();
    }, [
        startCloseHoverPageCardTimer
    ]);
    return {
        closeAllHoverPageCards: closeAllHoverPageCards,
        startCloseHoverPageCardTimer: startCloseHoverPageCardTimer,
        clearHoverPageCardTimers: clearHoverPageCardTimers,
        showHoverPageCardForItem: showHoverPageCardForItem,
        isHoverPageCardOptedIn: isHoverPageCardOptedIn,
        onEnterHoverTarget: onEnterHoverTarget,
        onLeaveHoverTarget: onLeaveHoverTarget,
        onBlurHoverTarget: onBlurHoverTarget
    };
};



var $lfFzM = parcelRequire("lfFzM");





var $BRSnR = parcelRequire("BRSnR");


var $j3kZx = parcelRequire("j3kZx");





const $d9810ba2fa073e42$export$d09f0ee316c3b5c1 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "06Lgw",
    name: "LazySpaceHoverPageCard",
    loader: async ()=>(await (parcelRequire("hKT2X"))).SpaceHoverPageCard
});



var $gz8ZY = parcelRequire("gz8ZY");


var $2vuKf = parcelRequire("2vuKf");


var $bOLC6 = parcelRequire("bOLC6");


var $arWla = parcelRequire("arWla");










const $add9014203bde61c$var$stopOrSucceed = (name, attributes, error, experienceTracker)=>{
    if (error) experienceTracker.stopOnError({
        name: name,
        attributes: attributes,
        error: error
    });
    else experienceTracker.succeed({
        name: name,
        attributes: attributes
    });
};
const $add9014203bde61c$export$122d712fe0dbd67 = ({ loading: loading, error: error, persistenceError: persistenceError, persistenceUpdateLoading: persistenceUpdateLoading, persistenceUpdateError: persistenceUpdateError, spaceViewsSort: spaceViewsSort, setSpaceViewsSort: setSpaceViewsSort, isSpaceAdmin: isSpaceAdmin })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const makeTrackedFetchMore = (0, $42omo.useCallback)((fetchMore)=>()=>{
            experienceTracker.start({
                name: (0, $irVI7.SPACE_VIEWS_PAGINATE_EXPERIENCE)
            });
            fetchMore();
        }, [
        experienceTracker
    ]);
    const trackedSetSpaceViewsSort = (0, $42omo.useCallback)((newSort)=>{
        experienceTracker.start({
            name: (0, $irVI7.SPACE_VIEWS_CHANGE_EXPERIENCE),
            attributes: {
                prevSort: spaceViewsSort
            }
        });
        setSpaceViewsSort(newSort);
    }, [
        experienceTracker,
        spaceViewsSort,
        setSpaceViewsSort
    ]);
    (0, $42omo.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.SPACE_VIEWS_INITIAL_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!loading && !persistenceUpdateLoading) {
            const attributes = {
                spaceViewsSort: spaceViewsSort
            };
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_INITIAL_EXPERIENCE), {
                spaceViewsSort: spaceViewsSort,
                isSpaceAdmin: isSpaceAdmin
            }, error || persistenceError, experienceTracker);
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_CHANGE_EXPERIENCE), attributes, error || persistenceUpdateError, experienceTracker);
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_PAGINATE_EXPERIENCE), attributes, error, experienceTracker);
        }
    }, [
        experienceTracker,
        loading,
        error,
        persistenceError,
        persistenceUpdateLoading,
        persistenceUpdateError,
        spaceViewsSort,
        isSpaceAdmin
    ]);
    return {
        makeTrackedFetchMore: makeTrackedFetchMore,
        trackedSetSpaceViewsSort: trackedSetSpaceViewsSort
    };
};



const $5a12275e9873d32f$var$SpaceViews = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-2bnv",
    name: "SpaceViews",
    loader: async ()=>(await (parcelRequire("g74Jl"))).SpaceViews
});

const $5a12275e9873d32f$var$PagesItemActions = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ctWVd",
    name: "PagesItemActions",
    loader: async ()=>(await (parcelRequire("1wY8Z"))).PagesItemActions
});

const $5a12275e9873d32f$var$ContentTreeSearchLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Dl_eE",
    name: "ContentTreeSearchLoader",
    loader: async ()=>(await (parcelRequire("663u0"))).ContentTreeSearch
});
const $5a12275e9873d32f$var$i18n = (0, $cgtv4.defineMessages)({
    contentTitle: {
        id: "space-views.collapsible-section.title",
        defaultMessage: "Content"
    },
    multiSelectContentTitle: {
        id: "space-views.collapsible-section.title.multi-select",
        defaultMessage: "Multi-select content"
    },
    contentTooltip: {
        id: "space-views.collapsible-section.title.tooltip",
        defaultMessage: "Organize content in this space"
    }
});
const $5a12275e9873d32f$var$SpaceViewsControllerComponent = ({ onDragDropSuccess: onDragDropSuccess, isPeekingFromBlogs: isPeekingFromBlogs, spaceHasUserContent: spaceHasUserContent, homepageId: homepageId, onContentTreeLoadComplete: onContentTreeLoadComplete, pageTreeFinishedLoading: pageTreeFinishedLoading })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isSuperAdmin: isSuperAdmin } = (0, $lfFzM.useIsSuperAdmin)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [pageContextContentType] = (0, $ep3mz.useContentType)();
    const { isLicensed: isLicensed, edition: edition } = (0, $bQm3c.useSessionData)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { spaceViewsSort: spaceViewsSort, setSpaceViewsSort: setSpaceViewsSort, queryLoading: persistenceLoading, queryError: persistenceError, mutationLoading: persistenceUpdateLoading, mutationError: persistenceUpdateError } = (0, $bOLC6.useSpaceViewsOptions)(// @ts-ignore FIXME: `spaceKey` can be `undefined` here, and needs proper handling
    spaceKey, isLicensed);
    const forceExpandBecauseViewingContentTree = pageContextContentType !== 'blogpost';
    const [isPageTreeLoading, setIsPageTreeLoading] = (0, $42omo.useState)(true);
    const [pageTreeError, setPageTreeError] = (0, $42omo.useState)();
    const [isSpaceViewsLoading, setIsSpaceViewsLoading] = (0, $42omo.useState)(true);
    const [contentTreeSize, setContentTreeSize] = (0, $42omo.useState)(0);
    const [spaceViewsError, setSpaceViewsError] = (0, $42omo.useState)();
    const isPageTree = spaceViewsSort === 'TREE';
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    // Ref to the space views menu trigger button in the content header
    const spaceViewsMenuTriggerRef = (0, $42omo.useRef)(null);
    const { data: data, loading: isSpaceAdminQueryLoading, error: isSpaceAdminQueryError } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query SpaceViewsControllerQuery($spaceKey:String!){space(key:$spaceKey){id currentUser{isAdmin}}}`, {
        variables: {
            spaceKey: spaceKey ?? ''
        }
    });
    const loading = persistenceLoading || (isPageTree ? isPageTreeLoading : isSpaceViewsLoading) || isSpaceAdminQueryLoading;
    const error = pageTreeError || spaceViewsError || isSpaceAdminQueryError;
    const isSpaceAdmin = Boolean(data?.space?.currentUser?.isAdmin);
    const isSpaceAdminOrSuperAdmin = isSpaceAdmin || isSuperAdmin;
    const { trackedSetSpaceViewsSort: trackedSetSpaceViewsSort, makeTrackedFetchMore: makeTrackedFetchMore } = (0, $add9014203bde61c$export$122d712fe0dbd67)({
        loading: loading,
        error: error,
        persistenceError: persistenceError,
        persistenceUpdateLoading: persistenceUpdateLoading,
        persistenceUpdateError: persistenceUpdateError,
        spaceViewsSort: spaceViewsSort,
        setSpaceViewsSort: setSpaceViewsSort,
        isSpaceAdmin: isSpaceAdmin
    });
    const { onEnterHoverTarget: showHoverPageCardOnEnterHoverTarget, closeAllHoverPageCards: closeAllHoverPageCards, startCloseHoverPageCardTimer: startCloseHoverPageCardTimer, clearHoverPageCardTimers: clearHoverPageCardTimers, showHoverPageCardForItem: showHoverPageCardForItem, isHoverPageCardOptedIn: isHoverPageCardOptedIn, onLeaveHoverTarget: onLeaveHoverTarget, onBlurHoverTarget: onBlurHoverTarget } = (0, $f35e894e447c6262$export$3bba19b3f6dc31cd)(spaceViewsSort);
    const [shouldRenderAfterIcon, setShouldRenderAfterIcon] = (0, $42omo.useState)(false);
    const onEnterHoverTarget = (0, $42omo.useCallback)(({ itemID: itemID, isQuickActionsFocused: isQuickActionsFocused, hoverPageCardTriggerRef: hoverPageCardTriggerRef, isContextualCreateFocused: isContextualCreateFocused })=>{
        showHoverPageCardOnEnterHoverTarget({
            itemID: itemID,
            isQuickActionsFocused: isQuickActionsFocused,
            hoverPageCardTriggerRef: hoverPageCardTriggerRef,
            isContextualCreateFocused: isContextualCreateFocused
        });
        setShouldRenderAfterIcon(true);
    }, [
        showHoverPageCardOnEnterHoverTarget,
        setShouldRenderAfterIcon
    ]);
    const { isExpanded: isExpanded, onExpansionToggle: onExpansionToggle } = (0, $j3kZx.useSpacePersistentExpansion)({
        sectionName: 'contentTree',
        collapsedByDefault: !forceExpandBecauseViewingContentTree,
        forceExpand: forceExpandBecauseViewingContentTree
    });
    const handleSpaceViewCleared = (0, $42omo.useCallback)(()=>{
        // Focus the space views menu trigger button in the content header using React ref
        if (spaceViewsMenuTriggerRef.current) spaceViewsMenuTriggerRef.current.focus();
    }, [
        spaceViewsMenuTriggerRef
    ]);
    const renderContentTree = (0, $42omo.useMemo)(()=>{
        if (persistenceLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arWla.FlexCenter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "medium"
        }));
        const hoverPageCardProps = {
            onEnterHoverTarget: onEnterHoverTarget,
            closeAllHoverPageCards: closeAllHoverPageCards,
            isHoverPageCardOptedIn: isHoverPageCardOptedIn,
            onLeaveHoverTarget: onLeaveHoverTarget,
            onBlurHoverTarget: onBlurHoverTarget
        };
        if (isPageTree) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a12275e9873d32f$var$ContentTreeSearchLoader, {
            contentTreeSize: contentTreeSize,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            selection: spaceViewsSort,
            setSelection: trackedSetSpaceViewsSort,
            isLicensed: isLicensed,
            isSpaceAdminOrSuperAdmin: isSpaceAdminOrSuperAdmin,
            ...hoverPageCardProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3qtLb.PageTree), {
            onDragDropSuccess: onDragDropSuccess,
            isPeekingFromBlogs: isPeekingFromBlogs,
            isSuperAdmin: isSuperAdmin,
            setIsPageTreeLoading: setIsPageTreeLoading,
            setPageTreeError: setPageTreeError,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            homepageId: homepageId,
            setContentTreeSize: setContentTreeSize,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            ...hoverPageCardProps
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a12275e9873d32f$var$SpaceViews, {
            spaceViewsSort: spaceViewsSort,
            setIsSpaceViewsLoading: setIsSpaceViewsLoading,
            setSpaceViewsError: setSpaceViewsError,
            trackedSetSpaceViewsSort: trackedSetSpaceViewsSort,
            makeTrackedFetchMore: makeTrackedFetchMore,
            spaceKey: spaceKey,
            contentId: contentId,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            contentTreeSize: contentTreeSize,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            onSpaceViewCleared: handleSpaceViewCleared,
            ...hoverPageCardProps
        });
    }, [
        persistenceLoading,
        onEnterHoverTarget,
        closeAllHoverPageCards,
        isHoverPageCardOptedIn,
        onLeaveHoverTarget,
        onBlurHoverTarget,
        isPageTree,
        spaceViewsSort,
        trackedSetSpaceViewsSort,
        makeTrackedFetchMore,
        spaceKey,
        contentId,
        shouldRenderAfterIcon,
        contentTreeSize,
        onContentTreeLoadComplete,
        isLicensed,
        onDragDropSuccess,
        isPeekingFromBlogs,
        isSuperAdmin,
        homepageId,
        isSpaceAdminOrSuperAdmin,
        handleSpaceViewCleared
    ]);
    if (isNav4Enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c1ydB.ExpandableMenuItem), {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "nav4-spotlight-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cNRxA.ExpandableMenuItemTrigger), {
        elemBefore: isMultiSelectActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4NZXC))), {
            label: "",
            color: "currentColor"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bTdbD))), {
            label: "",
            color: "currentColor"
        }),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a12275e9873d32f$var$PagesItemActions, {
            isLicensed: isLicensed,
            edition: edition ?? undefined,
            selection: spaceViewsSort,
            setSelection: trackedSetSpaceViewsSort,
            spaceKey: spaceKey || '',
            expandContentSection: ()=>onExpansionToggle(true),
            onItemClick: ()=>onExpansionToggle(true),
            spaceHasUserContent: spaceHasUserContent,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            isSpaceAdminOrSuperAdmin: isSpaceAdminOrSuperAdmin,
            spaceViewsMenuTriggerRef: spaceViewsMenuTriggerRef
        })
    }, isMultiSelectActive ? formatMessage($5a12275e9873d32f$var$i18n.multiSelectContentTitle) : formatMessage($5a12275e9873d32f$var$i18n.contentTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dXXAF.ExpandableMenuItemContent), null, renderContentTree, isHoverPageCardOptedIn && showHoverPageCardForItem.itemID ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d9810ba2fa073e42$export$d09f0ee316c3b5c1), {
        showHoverPageCardForItem: showHoverPageCardForItem,
        closeAllHoverPageCards: closeAllHoverPageCards,
        clearHoverPageCardTimers: clearHoverPageCardTimers,
        startCloseHoverPageCardTimer: startCloseHoverPageCardTimer,
        onBlurHoverTarget: onBlurHoverTarget,
        shouldUseAutomationDiscovery: true,
        key: showHoverPageCardForItem.itemID
    }) : null, persistenceError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: persistenceError
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $BRSnR.SpacePersistentCollapsibleSectionLoader), {
        renderAfterIconButton: (setHeaderExpandedState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5a12275e9873d32f$var$PagesItemActions, {
                isLicensed: isLicensed,
                selection: spaceViewsSort,
                setSelection: trackedSetSpaceViewsSort,
                spaceKey: spaceKey || '',
                onItemClick: ()=>setHeaderExpandedState?.(true),
                spaceHasUserContent: spaceHasUserContent,
                pageTreeFinishedLoading: pageTreeFinishedLoading,
                isSpaceAdminOrSuperAdmin: isSpaceAdminOrSuperAdmin,
                spaceViewsMenuTriggerRef: spaceViewsMenuTriggerRef
            }),
        headerTitle: formatMessage($5a12275e9873d32f$var$i18n.contentTitle),
        sectionName: "contentTree",
        tooltipContent: formatMessage($5a12275e9873d32f$var$i18n.contentTooltip)
    }, renderContentTree, isHoverPageCardOptedIn && showHoverPageCardForItem.itemID ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d9810ba2fa073e42$export$d09f0ee316c3b5c1), {
        showHoverPageCardForItem: showHoverPageCardForItem,
        closeAllHoverPageCards: closeAllHoverPageCards,
        clearHoverPageCardTimers: clearHoverPageCardTimers,
        startCloseHoverPageCardTimer: startCloseHoverPageCardTimer,
        onBlurHoverTarget: onBlurHoverTarget,
        shouldUseAutomationDiscovery: true,
        key: showHoverPageCardForItem.itemID
    }) : null, persistenceError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: persistenceError
    }));
};
const $5a12275e9873d32f$export$5bb6552a789f7a6f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, $5a12275e9873d32f$var$SpaceViewsControllerComponent({
        ...props
    }));









const $2956b96ada85ef60$export$a2e535ad780a85fe = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9L4J0",
    name: "BlogTree",
    loader: async ()=>(await (parcelRequire("msvBN"))).BlogTree
});



var $6mKj3 = parcelRequire("6mKj3");

const $72da3bb5b7695f3e$export$7716f65eb5d1a3fd = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(24);
    const { showShortcutsSection: showShortcutsSection, space: space, spaceKey: spaceKey, quick: quick, homepageId: homepageId, loading: loading, isSpaceAdmin: isSpaceAdmin, isBlogNavigation: isBlogNavigation, blogsHidden: blogsHidden, pageTreeFinishedLoading: pageTreeFinishedLoading, onDragDropSuccess: onDragDropSuccess, onContentTreeLoadComplete: onContentTreeLoadComplete } = t0;
    let t1;
    if ($[0] !== isSpaceAdmin || $[1] !== quick || $[2] !== showShortcutsSection || $[3] !== space?.id || $[4] !== spaceKey) {
        t1 = showShortcutsSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $16e27872478384c0$export$7f1bcb54a9a4d80e), {
            isSpaceAdmin: isSpaceAdmin,
            spaceKey: spaceKey,
            links: quick,
            spaceId: space?.id || null
        });
        $[0] = isSpaceAdmin;
        $[1] = quick;
        $[2] = showShortcutsSection;
        $[3] = space?.id;
        $[4] = spaceKey;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== homepageId || $[7] !== isBlogNavigation || $[8] !== loading || $[9] !== onContentTreeLoadComplete || $[10] !== onDragDropSuccess || $[11] !== pageTreeFinishedLoading || $[12] !== space?.didContainUserContent || $[13] !== spaceKey) {
        t2 = !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": "pageTree",
            "data-testid": "pageTree",
            onMouseEnter: (0, $6mKj3.expVal)("confluence_frontend_remove_hydrateonhover_pagetree", "isEnabled", false) ? undefined : (0, $3qtLb.PageTreeLoaderOnHover).hydrateOnHover
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5a12275e9873d32f$export$5bb6552a789f7a6f), {
            key: spaceKey,
            homepageId: homepageId,
            onDragDropSuccess: onDragDropSuccess,
            isPeekingFromBlogs: isBlogNavigation,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            spaceHasUserContent: space?.didContainUserContent,
            pageTreeFinishedLoading: pageTreeFinishedLoading
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null);
        $[6] = homepageId;
        $[7] = isBlogNavigation;
        $[8] = loading;
        $[9] = onContentTreeLoadComplete;
        $[10] = onDragDropSuccess;
        $[11] = pageTreeFinishedLoading;
        $[12] = space?.didContainUserContent;
        $[13] = spaceKey;
        $[14] = t2;
    } else t2 = $[14];
    let t3;
    if ($[15] !== blogsHidden || $[16] !== loading || $[17] !== pageTreeFinishedLoading || $[18] !== spaceKey) {
        t3 = !loading && !blogsHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2956b96ada85ef60$export$a2e535ad780a85fe), {
            spaceKey: spaceKey,
            pageTreeFinishedLoading: pageTreeFinishedLoading
        });
        $[15] = blogsHidden;
        $[16] = loading;
        $[17] = pageTreeFinishedLoading;
        $[18] = spaceKey;
        $[19] = t3;
    } else t3 = $[19];
    let t4;
    if ($[20] !== t1 || $[21] !== t2 || $[22] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2, t3);
        $[20] = t1;
        $[21] = t2;
        $[22] = t3;
        $[23] = t4;
    } else t4 = $[23];
    return t4;
} : ({ showShortcutsSection: showShortcutsSection, space: space, spaceKey: spaceKey, quick: quick, homepageId: homepageId, loading: loading, isSpaceAdmin: isSpaceAdmin, isBlogNavigation: isBlogNavigation, blogsHidden: blogsHidden, pageTreeFinishedLoading: pageTreeFinishedLoading, onDragDropSuccess: onDragDropSuccess, onContentTreeLoadComplete: onContentTreeLoadComplete })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, showShortcutsSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $16e27872478384c0$export$7f1bcb54a9a4d80e), {
        isSpaceAdmin: isSpaceAdmin,
        spaceKey: spaceKey,
        links: quick,
        spaceId: space?.id || null
    }), !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "pageTree",
        "data-testid": "pageTree",
        onMouseEnter: (0, $6mKj3.expVal)('confluence_frontend_remove_hydrateonhover_pagetree', 'isEnabled', false) ? undefined : (0, $3qtLb.PageTreeLoaderOnHover).hydrateOnHover
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5a12275e9873d32f$export$5bb6552a789f7a6f), {
        key: spaceKey,
        homepageId: homepageId,
        onDragDropSuccess: onDragDropSuccess,
        isPeekingFromBlogs: isBlogNavigation,
        onContentTreeLoadComplete: onContentTreeLoadComplete,
        spaceHasUserContent: space?.didContainUserContent,
        pageTreeFinishedLoading: pageTreeFinishedLoading
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null), !loading && !blogsHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2956b96ada85ef60$export$a2e535ad780a85fe), {
        spaceKey: spaceKey,
        pageTreeFinishedLoading: pageTreeFinishedLoading
    }));
module.exports["CommonSpaceNavigationContent"] = $72da3bb5b7695f3e$export$7716f65eb5d1a3fd;

});

parcelRegister("8NpIa", function(module, exports) {

let $6676d8131a503b11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6676d8131a503b11$var$load("jg5LT"),
    $6676d8131a503b11$var$load("eiooB"),
    $6676d8131a503b11$var$load("iLyOq"),
    $6676d8131a503b11$var$load("kUbUu"),
    $6676d8131a503b11$var$load("2YffH"),
    $6676d8131a503b11$var$load("fLZBc"),
    $6676d8131a503b11$var$load("bg5OF"),
    $6676d8131a503b11$var$load("clQc9"),
    $6676d8131a503b11$var$load("8PPsf"),
    $6676d8131a503b11$var$load("7f9Fz"),
    $6676d8131a503b11$var$load("5U3YO"),
    $6676d8131a503b11$var$load("8YSo7"),
    $6676d8131a503b11$var$load("9XYQ9"),
    $6676d8131a503b11$var$load("Wowvf"),
    $6676d8131a503b11$var$load("amdBm"),
    $6676d8131a503b11$var$load("hhss7"),
    $6676d8131a503b11$var$load("6wr18"),
    $6676d8131a503b11$var$load("kjZZD"),
    $6676d8131a503b11$var$load("jXx9i"),
    $6676d8131a503b11$var$load("ffEVr"),
    $6676d8131a503b11$var$load("gZGoR"),
    $6676d8131a503b11$var$load("jk2zg"),
    $6676d8131a503b11$var$load("jyfIr"),
    $6676d8131a503b11$var$load("75V2Q"),
    $6676d8131a503b11$var$load("7EorR"),
    $6676d8131a503b11$var$load("1NnjK")
]).then(()=>parcelRequire('eTFt9'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("BRSnR", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $72bb589685e69b08$export$5cfd593e5b6c4e39 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "0iKk_",
    name: "SpacePersistentCollapsibleSectionLoader",
    loader: async ()=>(await (parcelRequire("5BGgS"))).SpacePersistentCollapsibleSection
});
module.exports["SpacePersistentCollapsibleSectionLoader"] = $72bb589685e69b08$export$5cfd593e5b6c4e39;

});

parcelRegister("5BGgS", function(module, exports) {

let $415132a2f431138a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $415132a2f431138a$var$load("dviIw"),
    $415132a2f431138a$var$load("kBLei")
]).then(()=>parcelRequire('b9VQF'));

});

parcelRegister("hKT2X", function(module, exports) {

let $ced16ea7cf72fc33$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ced16ea7cf72fc33$var$load("amdBm"),
    $ced16ea7cf72fc33$var$load("ipcqi"),
    $ced16ea7cf72fc33$var$load("3wb6c"),
    $ced16ea7cf72fc33$var$load("gZGoR"),
    $ced16ea7cf72fc33$var$load("6iKyY"),
    $ced16ea7cf72fc33$var$load("9iZkh"),
    $ced16ea7cf72fc33$var$load("6wr18"),
    $ced16ea7cf72fc33$var$load("2t3HP"),
    $ced16ea7cf72fc33$var$load("ev7SX"),
    $ced16ea7cf72fc33$var$load("gLGsg"),
    $ced16ea7cf72fc33$var$load("k2R9e"),
    $ced16ea7cf72fc33$var$load("7kkP6"),
    $ced16ea7cf72fc33$var$load("h4Nf7"),
    $ced16ea7cf72fc33$var$load("1iUSs"),
    $ced16ea7cf72fc33$var$load("jbxHq"),
    $ced16ea7cf72fc33$var$load("k8XPW"),
    $ced16ea7cf72fc33$var$load("fWCRm"),
    $ced16ea7cf72fc33$var$load("Wowvf"),
    $ced16ea7cf72fc33$var$load("cyGuT"),
    $ced16ea7cf72fc33$var$load("hhss7"),
    $ced16ea7cf72fc33$var$load("7u4WP"),
    $ced16ea7cf72fc33$var$load("ffEVr"),
    $ced16ea7cf72fc33$var$load("jk2zg"),
    $ced16ea7cf72fc33$var$load("7EorR"),
    $ced16ea7cf72fc33$var$load("kUbUu"),
    $ced16ea7cf72fc33$var$load("cQVtz")
]).then(()=>parcelRequire('k8aVt'));

});

parcelRegister("bOLC6", function(module, exports) {
/**
 * @generated SignedSource<<1e99a80971f27cbfb1a191a696e406fb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a3f5a4229d0143cd$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "spaceKey"
        }
    ],
    "kind": "Fragment",
    "name": "useSpaceViewsOptionsSpaceViewsPersistenceWriteFragment",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "spaceViewsPersistence"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "UserPreferences"
};
$a3f5a4229d0143cd$var$node.hash = "9ec903133829a75826057a66a4a62727";
var $a3f5a4229d0143cd$export$2e2bcd8739ae039 = $a3f5a4229d0143cd$var$node;



var $3AeIf = parcelRequire("3AeIf");

/**
 * @generated SignedSource<<6565ef7fe5ad6d9aeb4c2193c86bde80>>
 * @relayHash 197595cb76d03c058f5fbb845dc266a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 89a76fcc88ae0753908f2aaff4b8debcf7a025d460506fe67d47266e32c2ec9b
const $2bef0e4e0b22cfa3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "persistenceOption"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "persistenceOption",
                                    "variableName": "persistenceOption"
                                },
                                v2 /*: any*/ 
                            ],
                            "kind": "ObjectValue",
                            "name": "spaceViewsPersistence"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ 
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "197595cb76d03c058f5fbb845dc266a1",
            "id": "89a76fcc88ae0753908f2aaff4b8debcf7a025d460506fe67d47266e32c2ec9b",
            "metadata": {},
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "operationKind": "mutation",
            "text": "mutation useSpaceViewsOptionsSpaceViewsPersistenceMutation($spaceKey:String!,$persistenceOption:SpaceViewsPersistenceOption!){updateUserPreferences(userPreferences:{spaceViewsPersistence:{spaceKey:$spaceKey,persistenceOption:$persistenceOption}}){spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$2bef0e4e0b22cfa3$var$node.hash = "c904b4b947ce0e659a2538aaffec18be";
var $2bef0e4e0b22cfa3$export$2e2bcd8739ae039 = $2bef0e4e0b22cfa3$var$node;



var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $ij4CE = parcelRequire("ij4CE");

const $c39f0c35d43dec0d$var$useSpaceViewsOptionsSpaceViewsPersistenceMutation = (0, $2bef0e4e0b22cfa3$export$2e2bcd8739ae039);
const $c39f0c35d43dec0d$var$useSpaceViewsOptionsPersistenceQuery = (0, $3AeIf.default);
const $c39f0c35d43dec0d$export$1723fb5a667b3274 = (0, $cgtv4.defineMessages)({
    TREE: {
        id: "space-views.tree",
        defaultMessage: "Tree"
    },
    RECENTLY_VIEWED: {
        id: "space-views.recently.viewed",
        defaultMessage: "My visits"
    },
    RECENTLY_MODIFIED: {
        id: "space-views.recently.modified.nonfinal",
        // Remove .nonfinal suffix when copy is finalized
        defaultMessage: "Last updated"
    },
    TITLE_AZ: {
        id: "space-views.a-z.desc",
        defaultMessage: "Title - A to Z"
    }
});
const $c39f0c35d43dec0d$export$d285edfa1d91469 = (spaceKey, isLicensed = false)=>{
    const { data: data, loading: queryLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($c39f0c35d43dec0d$var$useSpaceViewsOptionsPersistenceQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: !isLicensed
    });
    const [updatePersistence, { loading: mutationLoading, error: mutationError }] = (0, $308Wd.useMutationInterop)($c39f0c35d43dec0d$var$useSpaceViewsOptionsSpaceViewsPersistenceMutation);
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $a3f5a4229d0143cd$export$2e2bcd8739ae039)
    });
    const setSpaceViewsSort = (0, $42omo.useCallback)((newSort)=>{
        updatePersistence({
            variables: {
                spaceKey: spaceKey,
                persistenceOption: newSort
            }
        }).catch(()=>{}); // ignoring errors here because we are consuming error from useMutation
        // Update the cache to keep UI updated regardless of whether the mutation succeeds
        if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) writeFragmentInterop({
            fragmentId: `$ROOT_QUERY.userPreferences`,
            data: {
                spaceViewsPersistence: newSort,
                __typename: 'UserPreferences'
            },
            variables: {
                spaceKey: spaceKey
            }
        });
        else (0, $fEmGS.writeQueryInterop)({
            query: $c39f0c35d43dec0d$var$useSpaceViewsOptionsPersistenceQuery,
            variables: {
                spaceKey: spaceKey
            },
            data: {
                userPreferences: {
                    spaceViewsPersistence: newSort,
                    __typename: 'UserPreferences'
                }
            }
        });
    }, [
        spaceKey,
        updatePersistence,
        writeFragmentInterop
    ]);
    const spaceViewsSort = data?.userPreferences?.spaceViewsPersistence || 'TREE'; //tree is default
    return {
        spaceViewsSort: spaceViewsSort,
        setSpaceViewsSort: setSpaceViewsSort,
        queryLoading: queryLoading,
        queryError: queryError,
        mutationLoading: mutationLoading,
        mutationError: mutationError
    };
};
module.exports["sortI18n"] = $c39f0c35d43dec0d$export$1723fb5a667b3274;
module.exports["useSpaceViewsOptions"] = $c39f0c35d43dec0d$export$d285edfa1d91469;

});

parcelRegister("arWla", function(module, exports) {
/* PresentationalComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $eEA8O = parcelRequire("eEA8O");

const $c4de3c3a60bbeec4$var$buttonStyle = null;
const $c4de3c3a60bbeec4$var$menuButtonIconColor = (isWhiteboardBetaEnabled)=>{
    return isWhiteboardBetaEnabled ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)";
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$266a769812832828 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_s1xtjf": (0, $7sObp.default)($c4de3c3a60bbeec4$var$menuButtonIconColor(__cmplp.isWhiteboardBetaEnabled))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _bfhk1j28 _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg _80omtlke _i2zu1q3r _19lcplhp",
            __cmplp.isOpen ? "_1efs18pu" : "_1efsdgkc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$7d1bd82e49cf3a3b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _11c81o8v _ca0qt94y _u5f31l7b _n3tdt94y _19bv1l7b _bfhki8nm _syazi7uo _k48pmoej",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$74be2ccc72ce5bce = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$11b902a59791d036 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$bbba74ab4c493bc2 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8wo40",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c4de3c3a60bbeec4$export$851411cf794a4cc4 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pk1y44 _2hwx1y44 _otyr1y44 _18u0ftgi _2rko1rr0 _1yt418iy _19itglyw _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _bfhk1s93 _syaz1oa5 _1e0c1txw _4cvr1h6o _80omtlke",
            __cmplp.className
        ])
    });
});
const $c4de3c3a60bbeec4$export$97bdf39f6b82bb0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4utpp _18s817d0 _11c82smr _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _y3gn1h6o _4t3imgvx _syazi7uo",
            __cmplp.className
        ])
    });
});
const $c4de3c3a60bbeec4$export$b2471e0920d79944 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_otyru2gc",
            __cmplp.className
        ])
    });
});
module.exports["MenuButton"] = $c4de3c3a60bbeec4$export$266a769812832828;
module.exports["DefaultLabel"] = $c4de3c3a60bbeec4$export$7d1bd82e49cf3a3b;
module.exports["NoIcon"] = $c4de3c3a60bbeec4$export$74be2ccc72ce5bce;
module.exports["FlexCenter"] = $c4de3c3a60bbeec4$export$11b902a59791d036;
module.exports["MoreButtonContainer"] = $c4de3c3a60bbeec4$export$bbba74ab4c493bc2;
module.exports["CurrentViewPill"] = $c4de3c3a60bbeec4$export$851411cf794a4cc4;
module.exports["ErrorContainer"] = $c4de3c3a60bbeec4$export$97bdf39f6b82bb0;
module.exports["ErrorIconWrapper"] = $c4de3c3a60bbeec4$export$b2471e0920d79944;

});

parcelRegister("g74Jl", function(module, exports) {

let $bbb0f81e77d45c84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bbb0f81e77d45c84$var$load("kHOMt"),
    $bbb0f81e77d45c84$var$load("5TCys")
]).then(()=>parcelRequire('1wIcl'));

});

parcelRegister("1wY8Z", function(module, exports) {

let $11d76eef42222cdd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $11d76eef42222cdd$var$load("hhss7"),
    $11d76eef42222cdd$var$load("e8XZq"),
    $11d76eef42222cdd$var$load("6gmSt")
]).then(()=>parcelRequire('5SYww'));

});

parcelRegister("663u0", function(module, exports) {

let $4706013c0db30a82$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4706013c0db30a82$var$load("6wr18"),
    $4706013c0db30a82$var$load("4mgLr"),
    $4706013c0db30a82$var$load("a4yJG"),
    $4706013c0db30a82$var$load("hhss7"),
    $4706013c0db30a82$var$load("kJLy8"),
    $4706013c0db30a82$var$load("ffEVr"),
    $4706013c0db30a82$var$load("Wowvf"),
    $4706013c0db30a82$var$load("eQlG4")
]).then(()=>parcelRequire('32xcy'));

});

parcelRegister("msvBN", function(module, exports) {

let $04382b720f4c53f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $04382b720f4c53f8$var$load("6wr18"),
    $04382b720f4c53f8$var$load("e4XZ1"),
    $04382b720f4c53f8$var$load("5ppK3"),
    $04382b720f4c53f8$var$load("4mgLr"),
    $04382b720f4c53f8$var$load("lUQAm"),
    $04382b720f4c53f8$var$load("hhss7"),
    $04382b720f4c53f8$var$load("fZt2F"),
    $04382b720f4c53f8$var$load("ffEVr"),
    $04382b720f4c53f8$var$load("hDNUK")
]).then(()=>parcelRequire('esUj7'));

});

parcelRegister("d1wmn", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $dbff9ae313f922d4$export$94fe6747d9c16142 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "5XxyI",
    name: "ExternalCollaboratorInSpaceNotify",
    loader: async ()=>(await (parcelRequire("cv79u"))).ExternalCollaboratorInSpaceNotify
});
module.exports["ExternalCollaboratorInSpaceNotify"] = $dbff9ae313f922d4$export$94fe6747d9c16142;

});

parcelRegister("cv79u", function(module, exports) {

let $919ded8346cfe216$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $919ded8346cfe216$var$load("lnCW7").then(()=>parcelRequire('j8dZ5'));

});

parcelRegister("joey7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4343b3f26acaf51e$export$9c01e508282d4bd5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "U1K88",
    name: "GuestOnboardingModalLoadable",
    loader: async ()=>(await (parcelRequire("Hp5aQ"))).GuestOnboardingModal
});
module.exports["GuestOnboardingModalLoadable"] = $4343b3f26acaf51e$export$9c01e508282d4bd5;

});

parcelRegister("Hp5aQ", function(module, exports) {

let $0827791e94ebd627$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0827791e94ebd627$var$load("hhss7"),
    $0827791e94ebd627$var$load("7Ni3R")
]).then(()=>parcelRequire('jb3az'));

});


//# sourceMappingURL=Nav3SpaceNavigationContent.e633bd4d.js.map
